"use client";

import { useEffect } from "react";
import { Form, Input, Row, Col, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export default function InstrumentIdentificationForm({
  onFinish,
  initialValues,
  form,
}) {
  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  return (
    <div>
      <h3 style={{ marginBottom: "24px", fontWeight: "600" }}>
        Instrument Identification
      </h3>

      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        initialValues={initialValues}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  ISIN
                  <Tooltip title="International Securities Identification Number that uniquely identifies a security globally.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="isin"
              rules={[
                { required: true, message: "Please enter ISIN" },
                { min: 3, message: "ISIN must be at least 3 characters" },
                { max: 12, message: "ISIN cannot exceed 12 characters" },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="International identifier"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Local Code / Market Code
                  <Tooltip title="Local or exchange-specific code used to identify the security in a particular market.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="localCode"
              rules={[
                { required: true, message: "Please enter local code" },
                { min: 3, message: "Local code must be at least 3 characters" },
                { max: 12, message: "Local code cannot exceed 12 characters" },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="e.g., NTB-91D-2026, FGN-2030, etc."
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Security Name / Description
                  <Tooltip title="A name describing the security (issuer, tenor, rate, maturity).">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="instrumentName"
              rules={[
                { required: true, message: "Please enter security name" },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="Security Instrument Name/description"
              />
            </Form.Item>
          </Col>
        </Row>

        <button type="submit" style={{ display: "none" }} />
      </Form>
    </div>
  );
}
